// import React, { useState } from 'react';
// import {
//   Dialog, DialogTitle, DialogContent, DialogActions,
//   Box, Typography, TextField, Button, Link, Divider,
//   CircularProgress, Alert,
// } from '@mui/material';
// import UploadFileIcon from '@mui/icons-material/UploadFile';
// import { submitForensicAuditorAction } from './workflowApi';

// // Point this at your actual S3-hosted template, same pattern as the
// // affidavit/unfreeze templates already linked in staffDocsEpmsModal.jsx
// const AUDIT_REPORT_TEMPLATE_URL =
//   'https://splocamedia.s3.ap-south-1.amazonaws.com/templates/FORENSIC-AUDIT-REPORT-TEMPLATE.pdf';

// const ForensicAuditorActionDialog = ({ open, onClose, excessId, refId, excessAmt, onSuccess, onError }) => {
//   const [agreedAmount, setAgreedAmount] = useState('');
//   const [remarks, setRemarks] = useState('');
//   const [reportFile, setReportFile] = useState(null);
//   const [submitting, setSubmitting] = useState(false);

//   const reset = () => {
//     setAgreedAmount('');
//     setRemarks('');
//     setReportFile(null);
//   };

//   const handleClose = () => {
//     if (submitting) return;
//     reset();
//     onClose();
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     if (file.size > 2 * 1024 * 1024) {
//       onError('Report file must be under 2 MB.');
//       return;
//     }
//     setReportFile(file);
//   };

//   const buildFormData = (actionType) => {
//     const fd = new FormData();
//     fd.append('action_type', actionType);
//     fd.append('remarks', remarks);
//     if (agreedAmount) fd.append('agreed_amount_as_per_forensic_auditor', agreedAmount);
//     if (reportFile) fd.append('report_file', reportFile);
//     return fd;
//   };

//   const handleAction = async (actionType) => {
//     if (actionType === 'forward') {
//       if (!reportFile) {
//         onError('Please upload the audit report before forwarding.');
//         return;
//       }
//       if (!agreedAmount) {
//         onError('Please enter the agreed amount as per the audit.');
//         return;
//       }
//       const amt = parseFloat(agreedAmount);
//       if (!Number.isFinite(amt) || amt < 0) {
//         onError('Agreed amount must be a valid non-negative number.');
//         return;
//       }
//       if (excessAmt && amt > parseFloat(excessAmt)) {
//         onError('Agreed amount cannot exceed the excess amount.');
//         return;
//       }
//     }
//     try {
//       setSubmitting(true);
//       await submitForensicAuditorAction(excessId, buildFormData(actionType));
//       onSuccess(
//         actionType === 'forward'
//           ? 'Audit report submitted — case forwarded to Shirastedar.'
//           : 'Case sent back to Case Worker for modification.'
//       );
//       reset();
//       onClose();
//     } catch (err) {
//       onError(err?.response?.data?.error || 'Failed to record the audit action.');
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
//       <DialogTitle>Forensic Audit — {refId}</DialogTitle>
//       <DialogContent>
//         <Typography variant="body2" color="text.secondary" mb={1}>
//           Excess Amount on record: <strong>₹ {excessAmt || 0}</strong>
//         </Typography>

//         <Typography variant="body2" sx={{ mb: 2 }}>
//           Report template:{' '}
//           <Link href={AUDIT_REPORT_TEMPLATE_URL} target="_blank" rel="noopener">
//             Download here
//           </Link>
//         </Typography>

//         <Button
//           variant="outlined"
//           component="label"
//           fullWidth
//           startIcon={<UploadFileIcon />}
//           sx={{ mb: 2 }}
//         >
//           {reportFile ? reportFile.name : 'Upload Completed Audit Report (max 2 MB)'}
//           <input type="file" hidden onChange={handleFileChange} accept=".pdf,.doc,.docx" />
//         </Button>

//         <TextField
//           label="Agreed Amount (as per Forensic Auditor)"
//           type="number"
//           fullWidth
//           value={agreedAmount}
//           onChange={(e) => setAgreedAmount(e.target.value)}
//           sx={{ mb: 2 }}
//         />

//         <TextField
//           label="Remarks"
//           fullWidth
//           multiline
//           rows={3}
//           value={remarks}
//           onChange={(e) => setRemarks(e.target.value)}
//         />

//         <Divider sx={{ my: 2 }} />
//         <Alert severity="info">
//           <strong>Forward</strong> sends this to Shirastedar with the report attached.{' '}
//           <strong>Return</strong> sends it back to the Case Worker for more information —
//           no report is required to return.
//         </Alert>
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={handleClose} disabled={submitting}>Cancel</Button>
//         <Button
//           onClick={() => handleAction('return')}
//           color="warning"
//           variant="outlined"
//           disabled={submitting}
//         >
//           Return to Case Worker
//         </Button>
//         <Button
//           onClick={() => handleAction('forward')}
//           variant="contained"
//           disabled={submitting}
//           startIcon={submitting ? <CircularProgress size={16} color="inherit" /> : null}
//         >
//           {submitting ? 'Submitting...' : 'Forward to Shirastedar'}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default ForensicAuditorActionDialog;


import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Box, Typography, TextField, Button, Link, Divider,
  CircularProgress, Alert,
} from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { submitForensicAuditorAction } from './workflowApi';

// Point this at your actual S3-hosted template, same pattern as the
// affidavit/unfreeze templates already linked in staffDocsEpmsModal.jsx
const AUDIT_REPORT_TEMPLATE_URL =
  'https://splocamedia.s3.ap-south-1.amazonaws.com/templates/EPMS_document/IMA+excess+format.xlsx';

const ForensicAuditorActionDialog = ({ open, onClose, excessId, refId, excessAmt, onSuccess, onError }) => {
  const [agreedAmount, setAgreedAmount] = useState('');
  const [remarks, setRemarks] = useState('');
  const [reportFile, setReportFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const reset = () => {
    setAgreedAmount('');
    setRemarks('');
    setReportFile(null);
  };

  const handleClose = () => {
    if (submitting) return;
    reset();
    onClose();
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 2 * 1024 * 1024) {
      onError('Report file must be under 2 MB.');
      return;
    }
    setReportFile(file);
  };

  const buildFormData = (actionType) => {
    const fd = new FormData();
    fd.append('action_type', actionType);
    fd.append('remarks', remarks);
    if (agreedAmount) fd.append('agreed_amount_as_per_forensic_auditor', agreedAmount);
    if (reportFile) fd.append('report_file', reportFile);
    return fd;
  };

  const handleAction = async (actionType) => {
    if (actionType === 'forward') {
      if (!reportFile) {
        onError('Please upload the audit report before forwarding.');
        return;
      }
      if (!agreedAmount) {
        onError('Please enter the agreed amount as per the audit.');
        return;
      }
      const amt = parseFloat(agreedAmount);
      if (!Number.isFinite(amt) || amt < 0) {
        onError('Agreed amount must be a valid non-negative number.');
        return;
      }
      if (excessAmt && amt > parseFloat(excessAmt)) {
        onError('Agreed amount cannot exceed the excess amount.');
        return;
      }
    }
    try {
      setSubmitting(true);
      await submitForensicAuditorAction(excessId, buildFormData(actionType));
      onSuccess(
        actionType === 'forward'
          ? 'Audit report submitted — case forwarded to Shirastedar.'
          : 'Case sent back to Case Worker for modification.'
      );
      reset();
      onClose();
    } catch (err) {
      onError(err?.response?.data?.error || 'Failed to record the audit action.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Forensic Audit — {refId}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" mb={1}>
          Excess Amount on record: <strong>₹ {excessAmt || 0}</strong>
        </Typography>

        <Typography variant="body2" sx={{ mb: 2 }}>
          Report template:{' '}
          <Link href={AUDIT_REPORT_TEMPLATE_URL} target="_blank" rel="noopener">
            Download here
          </Link>
        </Typography>

        <Button
          variant="outlined"
          component="label"
          fullWidth
          startIcon={<UploadFileIcon />}
          sx={{ mb: 2 }}
        >
          {reportFile ? reportFile.name : 'Upload Completed Audit Report (max 2 MB)'}
          <input type="file" hidden onChange={handleFileChange} accept=".pdf,.doc,.docx" />
        </Button>

        <TextField
          label="Agreed Amount (as per Forensic Auditor)"
          type="number"
          fullWidth
          value={agreedAmount}
          onChange={(e) => setAgreedAmount(e.target.value)}
          sx={{ mb: 2 }}
        />

        <TextField
          label="Remarks"
          fullWidth
          multiline
          rows={3}
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
        />

        <Divider sx={{ my: 2 }} />
        <Alert severity="info">
          <strong>Forward</strong> sends this to Shirastedar with the report attached.{' '}
          <strong>Return</strong> sends it back to the Case Worker for more information —
          no report is required to return.
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={submitting}>Cancel</Button>
        <Button
          onClick={() => handleAction('return')}
          color="warning"
          variant="outlined"
          disabled={submitting}
        >
          Return to Case Worker
        </Button>
        <Button
          onClick={() => handleAction('forward')}
          variant="contained"
          disabled={submitting}
          startIcon={submitting ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {submitting ? 'Submitting...' : 'Forward to Shirastedar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ForensicAuditorActionDialog;